import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';

class ScrollToTop extends React.Component<RouteComponentProps> {
  componentDidUpdate(prevProps: RouteComponentProps) {
    const { location } = this.props;
    if (location.state && location.state.preserveScroll) {
      return;
    }
    if (location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    // eslint-disable-next-line react/destructuring-assignment
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);
